import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { GetAll } from "../../../../../../features/admin/sample_management/Slice";
import { formatDate } from "../../../../../../utils/common";

const Sample_Report_Table = ({ searchName }) => {
  const dispatch = useDispatch();
  const alldata = useSelector((state) => state.sample_management);

  const [currentPage, setCurrentPage] = useState(1);

  const login_id = useSelector((state) => state.auth.data);
  const id = login_id?.id;

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(FixIDS.Sample_management.Edit);
  // Fetch customers from API
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        createdAt: searchName.createdAt || "",
        unique_id: searchName.unique_id || "",
        method_of_testing: searchName.method_of_testing || "",
        tat: searchName.tat || "",
        sample_management_status_id:
          searchName.sample_management_status_id || "",
        name: searchName,
        start_date: searchName.start_date || "",
        end_date: searchName.end_date || "",
        page: page,
        per_page: alldata.per_page,
        customer_id: searchName.customer_id || "",
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [searchName, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Scheduled":
        return "orange";
      case "In Progress":
        return "blue";
      case "Verified":
        return "green";
      case "Pending Review":
        return "red";
      default:
        return "";
    }
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const handleRowCheckbox = (row) => {
    setSelectedRows((prev) => {
      const exists = prev.some((r) => r.id === row.id);

      if (exists) {
        // remove row
        return prev.filter((r) => r.id !== row.id);
      } else {
        // add full row
        return [...prev, row];
      }
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(alldata?.data);
    } else {
      setSelectedRows([]);
    }
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                {/* <th>
                  <input
                    type="checkbox"
                    checked={
                      Array.isArray(alldata?.data) &&
                      alldata?.data.length > 0 &&
                      selectedRows.length === alldata?.data.length
                    }
                    onChange={handleSelectAll}
                  />
                </th> */}
                <th>Sr.No</th>
                <th>Date</th>
                <th>Sample ID</th>
                <th>Customer Name</th>
                <th>Category</th>
                <th>Description Of The Sample</th>
                <th>No. Of Sample</th>
                <th>SAMP. Rec. Id</th>
                <th>Method Of Testing</th>
                <th>SAMP. Rec. Date</th>
                <th>SAMP. Rec. By</th>
                <th>Chemist Assigned</th>
                <th>TAT (Days)</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Authority</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(alldata.data) && alldata.data.length > 0 ? (
                alldata?.data.map((row, index) => {
                  return (
                    <tr
                      key={index}
                      className={index % 2 !== 0 ? "striped" : ""}
                    >
                      {/* <td>
                        <input
                          type="checkbox"
                          checked={selectedRows.some((r) => r.id === row.id)}
                          onChange={() => handleRowCheckbox(row)}
                        />
                      </td> */}
                      <td>
                        {(currentPage - 1) *
                          (alldata?.per_page || alldata?.data?.length || 0) +
                          index +
                          1}
                      </td>
                     <td>{formatDate(row?.createdAt)}</td>
                      <td>{row.unique_id}</td>
                      <td>{row.client?.name}</td>
                      <td>{row.Category?.name}</td>
                      <td>{row.description}</td>
                      <td>{row.no_of_samples}</td>
                      <td>{row.samp_rec}</td>
                      <td>{row.Method_Of_Testing?.name}</td>
                      <td>
                        {row.createdAt
                          ? new Date(
                              row.sample_recieved_date,
                            ).toLocaleDateString("en-IN")
                          : "-"}
                      </td>
                      <td>{row.sampleReceiver?.name}</td>
                      <td>{row.chemist?.name}</td>
                      <td>{row.tat_days}</td>
                      <td
                        className={
                          row.Priority?.name === "High"
                            ? "red"
                            : row.priority?.name === "Medium"
                            ? "orange"
                            : "green"
                        }
                      >
                        {row.Priority?.name}
                      </td>
                      <td
                        className={getStatusClass(
                          row.Sample_Management_Status?.name,
                        )}
                      >
                        {row.Sample_Management_Status?.name}
                      </td>
                      <td>{row.authority}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(alldata.current_page - 1) * alldata.per_page + 1} To{" "}
            {Math.min(alldata.current_page * alldata.per_page, alldata.total)}{" "}
            Of {alldata.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={alldata?.current_page}
            totalPages={alldata?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Sample_Report_Table;
